import React, { useState } from 'react'
import { Typography, Select, Skeleton } from 'antd'
import KaipassPlaceholder from 'Assets/images/kaipass_placeholder.png'

import './index.scss'

const KaiPassNotiPreview = ({ data }) => {
  const { title, image, content, btn_name } = data

  return (
    <div className="KaipassNotiPreviewComponent">
      <div className={`KaipassNotiPreviewScreen`}>
        <div className="window-preview">
          <img alt="brand-logo" className="image" src={image || KaipassPlaceholder}></img>
          <div className="content-wrapper">
            <div className="content">
              <p className="title">{title || 'Title'}</p>
              <p className="description">{content || 'Description'}</p>
            </div>
          </div>
          <div className="action-buttons-wrapper">
            <div className="action-button">{btn_name || 'Button'}</div>
          </div>
        </div>
      </div>
      {/* <div className="select-preview-device">
        <Select value={device} onChange={(value) => onChangeDevice(value)}>
          {platforms.map((platform) => (
            <Option key={platform.value} value={platform.value}>
              {platform.label}
            </Option>
          ))}
        </Select>
      </div> */}
    </div>
  )
}

export default KaiPassNotiPreview
